import { rootApi } from '../rootApi';

/**
 * Arac Modeli -> Egitim Turu eslesme tablosu (lms_vehicle_training_match).
 *
 * "Talep Edilen Egitimler" sekmesindeki (TrainingRequestForm.jsx) Egitim Turu alani, kullanici
 * bir Arac Modeli sectikten sonra bu uctan donen listeye gore daraltilir (kullanici talebi,
 * bkz. TrainingRequestForm.jsx uzerindeki not - onceki "aktif TUM egitim turleri" karari bu
 * uc ile degistirildi). "Yayinlanan Egitimler" akisindaki ayni amacli
 * v1/LmsCreateRequest/GetTrainingTypesByVehicleModel ucundan FARKLI, ayri bir BE kaynagi.
 *
 * Ornek yanit (data.items[]): { id, vehicleCode, vehicleName, trainingCode, trainingName,
 * isActive, ... }. `trainingCode`, formdaki `trainingType` alanina yazilan degerdir (TRAINING_TYPES
 * lookup grubundaki kodlarla ayni uzayi paylasiyor); `trainingName` yalnizca goruntu icin.
 */
export const lmsVehicleTrainingMatchApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsVehicleTrainingMatches: builder.query({
            query: ({ vehicleCode, isActive, pageNumber, pageSize }) => ({
                url: 'v1/LmsVehicleTrainingMatch/GetList',
                method: 'POST',
                body: {
                    vehicleCode,
                    isActive: isActive !== undefined ? isActive : 1,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 100
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return response.data.items;
                }
                return [];
            }
        }),
        getLmsVehicleTrainingMatchList: builder.query({
            query: ({
                vehicleCode = null,
                trainingCodes = [],
                isActive = 1,
                pageNumber = 1,
                pageSize = 10,
                filters = [],
                sorts = [],
                includeFilterOptions = false,
                filterOptionsColumns = []
            }) => ({
                url: 'v1/LmsVehicleTrainingMatch/GetList',
                method: 'POST',
                body: {
                    vehicleCode,
                    trainingCodes,
                    isActive,
                    pageNumber,
                    pageSize,
                    filters,
                    sorts,
                    includeFilterOptions,
                    filterOptionsColumns
                }
            }),
            transformResponse: (response) => ({
                items: response?.data?.items ?? [],
                totalCount: response?.data?.totalCount ?? 0,
                filterOptions: response?.data?.filterOptions ?? null
            }),
            providesTags: [{ type: 'LmsVehicleTrainingMatch', id: 'LIST' }]
        }),

        createLmsVehicleTrainingMatch: builder.mutation({
            query: (body) => ({
                url: 'v1/LmsVehicleTrainingMatch/Add',
                method: 'POST',
                body
            }),
            invalidatesTags: [{ type: 'LmsVehicleTrainingMatch', id: 'LIST' }]
        }),

        updateLmsVehicleTrainingMatch: builder.mutation({
            query: (body) => ({
                url: 'v1/LmsVehicleTrainingMatch/Update',
                method: 'POST',
                body
            }),
            invalidatesTags: [{ type: 'LmsVehicleTrainingMatch', id: 'LIST' }]
        }),

        deleteLmsVehicleTrainingMatch: builder.mutation({
            query: (id) => ({
                url: `v1/LmsVehicleTrainingMatch/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [{ type: 'LmsVehicleTrainingMatch', id: 'LIST' }]
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsVehicleTrainingMatchesQuery,
    useGetLmsVehicleTrainingMatchListQuery,
    useCreateLmsVehicleTrainingMatchMutation,
    useUpdateLmsVehicleTrainingMatchMutation,
    useDeleteLmsVehicleTrainingMatchMutation
} = lmsVehicleTrainingMatchApi;
